import { render, staticRenderFns } from "./PhotoSwipe.vue?vue&type=template&id=0b8e9451&scoped=true"
import script from "./PhotoSwipe.vue?vue&type=script&lang=js"
export * from "./PhotoSwipe.vue?vue&type=script&lang=js"
import style0 from "./PhotoSwipe.vue?vue&type=style&index=0&id=0b8e9451&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8e9451",
  null
  
)

export default component.exports